/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_6b619253{display:block}.resizeIsShort_6b619253{width:400px}.buttonGroup_6b619253{margin-bottom:40px}.buttonGroup_6b619253 button{margin-right:20px}.settingsGroup_6b619253{padding-top:20px}.itemCountDropdown_6b619253{width:180px}\n"}]);
export const root = "root_6b619253";
export const resizeIsShort = "resizeIsShort_6b619253";
export const buttonGroup = "buttonGroup_6b619253";
export const settingsGroup = "settingsGroup_6b619253";
export const itemCountDropdown = "itemCountDropdown_6b619253";